import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppComponent } from '../app.component';
import { FormControl, FormGroup, FormBuilder, FormsModule, Validators, Form } from '@angular/forms';

type NzSortOrder = 'ascend' | 'descend' | null;

@Component({
  selector: 'app-disposition-admin',
  templateUrl: './disposition-admin.component.html',
  styleUrl: './disposition-admin.component.css'
})
export class DispositionAdminComponent implements OnInit {
  isLoading = false;
  currentUser: any;
  dispositions: any[] = [];
  total: number = 0;
  pageSize = 100;
  pageIndex = 1;
  sortField = 'disposition_date';
  sortOrder: NzSortOrder = 'ascend';
  selectedProvider: any;
  availableProviders: any[] = [];
  availableProvidersByDist: any[] = [];
  availableCompanies: any[] = [];
  editModal: boolean = false;
  currentDisp: FormGroup;
  currentEditName: string = '';
  createDispo: FormGroup;
  createDispoModal: boolean = false;
  ;

  constructor(private data: DataserviceService,
    private message: NzMessageService,
    private app: AppComponent,
    private modal: NzModalService,
    private fb: FormBuilder) {

    this.currentUser = JSON.parse(localStorage.getItem('user')!);

    this.createDispo = new FormGroup(
      {
      dispName: new FormControl(null, Validators.required),
      abbreviation: new FormControl(null),
      text_color: new FormControl(null),
      provider_id: new FormControl(null, Validators.required),
      pin_color: new FormControl(null, Validators.required)
      }
    );
    this.currentDisp = new FormGroup(
      {
        id: new FormControl(null),
        disposition: new FormControl(null, Validators.required),
        abbreviation: new FormControl(null),
        text_color: new FormControl(null),
        pin: new FormControl(null, Validators.required),
        state_name: new FormControl(null, Validators.required)
      }
    );
  }
  ngOnInit(): void {
    this.getProviders();
    this.getCompanies();
    this.getProvidersByDist();
  }

  getProviders() {
    if (!this.currentUser.id) {
      console.error("No User ID found");
      return;
    }

    const url = `providers/providers-by-user/${this.currentUser.id}`;

    this.data.getData(url).subscribe((res: any) => {
      if (res.result === 'success') {
        this.availableProviders = res.data;
      } else {
        this.message.error(res.message);
      }
    });
  }
  
  getCompanies() {
    this.data.getData(`company/companies-by-distributor/${this.currentUser.distributor_id}`).subscribe((res: any) => {
      if (res.result === 'success') {
        this.availableCompanies = res.data;
      } else {
        this.message.error(res.message);
      }
    });
  }

  getProvidersByDist() {
    this.data.getData(`providers/providers-by-distributor/${this.currentUser.distributor_id}`).subscribe((res: any) => {
      if (res.result === 'success') {
        this.availableProvidersByDist = res.data;
      } else {
        this.message.error(res.message);
      }
    });
  }

  getData() {
    this.isLoading = true;

    if (!this.selectedProvider) {
      this.message.warning('Please select a provider first');
      this.isLoading = false;
      return;
    }

    const url = `disposition/dispositions-by-provider-listV2/${this.selectedProvider}`;

    this.data.getData(url).subscribe((res: any) => {
      if (res.result === 'success') {
        this.dispositions = res.data.map((item: any) => {
          return {
            ...item,
            state_name: item.state_name === 'active' ? true : false
          }
        });
        this.total = res.data.length;
      } else {
        this.message.error(res.message);
      }
      this.isLoading = false;
    });
  }

  editDisposition(disp: any) {
    this.currentDisp.setValue({
      id: disp.id,
      disposition: disp.disposition,
      abbreviation: disp.abbreviation,
      text_color: disp.text_color,
      pin: disp.pin,
      state_name: disp.state_name
    });
    this.editModal = true;
  };

  editDispositionSave() {
    this.isLoading = true;
    
    if(this.currentDisp.valid) {
    const b = {
      id: this.currentDisp.value.id,
      abbreviation: this.currentDisp.value.abbreviation,
      text_color: this.currentDisp.value.text_color,
      state_name: this.currentDisp.value.state_name === true ? 'active' : 'inactive',
      pin: this.currentDisp.value.pin,
      disposition: this.currentDisp.value.disposition
    };
    this.data.postDataNoBodyDotBody(b, 'disposition/edit-disposition').subscribe((res: any) => {
        if (res.result === 'success') {
          this.message.success('Disposition updated');
          this.getData(); // Refresh table
          this.isLoading = false;
          this.editModal = false;
        } else {
          this.message.error(res.message);
          this.isLoading = false;
          this.editModal = false;
       }
    })
  } else {
    this.message.error('Please fill in all required fields');
    Object.values(this.currentDisp.controls).forEach(control => {
      if (control.invalid) {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
        this.isLoading = false;
      }
     });
    }
  }

  editDispositionCancel() {
    this.editModal = false
  };

  createDisposition() {
    this.createDispoModal = true
  }

  createDispositionSave(): void {
    this.isLoading = true;
    if (this.createDispo.valid) {
    const b = {
      disposition: this.createDispo.value.dispName,
      provider_id: this.createDispo.value.provider_id,
      pin: this.createDispo.value.pin_color,
      abbreviation: this.createDispo.value.abbreviation,
      text_color: this.createDispo.value.text_color
    };
    this.data.postDataNoBodyDotBody(b, 'disposition/create-disposition').subscribe((res: any) => {
        if (res.result === 'success') {
          this.message.success('Disposition created');
          this.clearAndCloseDispoModal();
          this.getData(); // Refresh table
          this.isLoading = false;
        } else {
          this.message.error(res.message);
          this.isLoading = false;
          this.clearAndCloseDispoModal();
       }
    });
  } else {
    this.message.error('Please fill in all required fields');
    Object.values(this.createDispo.controls).forEach(control => {
      if (control.invalid) {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
        this.isLoading = false;
      }
     });
    };
  }

  createDispositionCancel() {
    this.clearAndCloseDispoModal();
  }

  clearAndCloseDispoModal() {
    this.createDispo.reset();
    this.createDispoModal = false;
  }
}
